import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { FileExists, isDomesticPartnerAffidavitRequired, isProofOfDisabilityRequired } from '../../components/attachment-validator';
import Attachment from "../../components/attachment";
import { AttachmentType } from '../../components/enums/attachment-type';
import { PlanType } from '../../components/enums/plan-type';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { WarningHexFilled16 } from '@carbon/icons-react';

const AttachmentReview = ({modifiedDependents, unmodifiedDependents, modifiedSelections, unmodifiedSelections, contacts}) => {
    const [proofOfDisability, setProofOfDisability] = useState();
    const [dpAffidavit, setDpAffidavit] = useState();
    const [attachments, setAttachments] = useState();
    const { formState, setValue, trigger } = useFormContext();
    const enrollments = useSelector(s => s.enrollments);

    useEffect(() => {
        if(Array.isArray(enrollments))
            return;
        let proofOfDisabilityRequired = false;
        let domesticPartnerAffidavitRequired = false;
        let disabledDependents = [];
        setAttachments(enrollments.attachments);
        modifiedDependents.forEach(d => {
            let unmodified = unmodifiedDependents?.find(s => s.id === d.id);
            if(!unmodified && !isNaN(d.id))
                unmodified = contacts?.find(s => s.id === d.id);
            if(isProofOfDisabilityRequired(d.relationship.id, d.birthdate, unmodified, d.id)){
                disabledDependents.push(d);
                proofOfDisabilityRequired = true;
            }
            if(isDomesticPartnerAffidavitRequired(d.relationship.id, unmodified, d.id, enrollments.selections)){
                setDpAffidavit(d);
                domesticPartnerAffidavitRequired = true;
            }
        });

        if(disabledDependents.length > 0)
            setProofOfDisability(disabledDependents)

        let isValid = true;
        if((proofOfDisabilityRequired && !FileExists(enrollments, AttachmentType.ProofOfDisability)) 
            || (domesticPartnerAffidavitRequired && !FileExists(enrollments, AttachmentType.DpAffidavit)))
            isValid = null;

        setValue("filesNeeded", isValid);
        trigger("filesNeeded");
    }, [enrollments]);

    return ( 
        <>
        {proofOfDisability || dpAffidavit ?
        <div className='mb-4'>
            <div className='my-2 text-xl text-danger'>
                Attachments
            </div>

            {proofOfDisability ? 
            <div className='border border-solid border-slate-200 rounded p-3 mb-2 bg-gray-50'>
            {proofOfDisability.map((d) =>
                    <div key={d.id}>
                        <div className='underline'>Proof of Disablity for {d.firstName} {d.lastName}</div>
                        <Attachment 
                            show={proofOfDisability} 
                            attachmentType={AttachmentType.ProofOfDisability} 
                            name="disabledFile"
                            buttonLabel="Upload Documentation (PDF file)"
                            labelDescription="Please upload supporting documentation showing proof of disability" 
                            label="Dependents older than 26 cannot be added unless disabled."
                            setAttachments={setAttachments}
                            attachments={attachments}
                            uploadOnChange={true}
                            />                
                    </div>
                )}
            </div>
            :<></>}
            {dpAffidavit ?
            <div className='border border-solid border-slate-200 rounded p-3 mb-2 bg-gray-50'>
                <div className='underline'>Domestic Partner Affidavit</div>
                <Attachment 
                        show={dpAffidavit} 
                        attachmentType={AttachmentType.DpAffidavit} 
                        name="domesticFile" 
                        buttonLabel="Upload affidavit (PDF file)" 
                        labelDescription="Please upload domestic partner affidavit" 
                        label="An affidavit is required for a domestic partnership"
                        setAttachments={setAttachments}
                        attachments={attachments}
                        uploadOnChange={true}
                    />

            </div>
            :<></>
            }
            <div className="text-danger text-sm font-semibold">
            {
                formState.errors["filesNeeded"]?.message ? <>
                <WarningHexFilled16 aria-label="alert" className="inline-block mb-1 mr-1" />
                
                {formState.errors["filesNeeded"]?.message}
                </> : <></>
            }
            </div>
            <hr />
        </div>
        : <></>}
        </>
     );
}
 
export default AttachmentReview;